import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a4a8969"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile" }
const _hoisted_2 = { class: "profile-img" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge" }, null, -1))
const _hoisted_5 = {
  class: "congratulations",
  "text-center": ""
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  "text-center": "",
  "padding-top": "",
  class: "ion-margin-top"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Hai guadagnato ")
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-margin-top" }, "Il tuo sfidante", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Ha guadagnato ")
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Ha guadagnato ")
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "ion-margin" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Vedi risultati")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Gioca un altro quiz")

import {
  IonContent,
  IonPage,
  IonButton,
  IonAvatar,
  IonModal,
} from '@ionic/vue';
// import './congratulations.scss'
import {ref} from "vue";
import MatchesService from "@/api/matches/MatchesService";
import ModalCongratulationsResult from './ModalCongratulationsResult.vue'
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const currentUser = ref<any>(JSON.parse(localStorage.getItem('userData') || '{}'))

const isOpenRef = ref(false);
const setOpen = (state: boolean) => isOpenRef.value = state;

const {
  getMatchResult,
  resolveChallengerAvatar,
  matchResultResolver,
  matchInRunResultResolver,
} = MatchesService()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      (_unref(getMatchResult)() && Object.values(_unref(getMatchResult)()).length > 1)
        ? (_openBlock(), _createBlock(_unref(IonContent), { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(IonAvatar), { class: "fit-avatar" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(resolveChallengerAvatar)(currentUser.value).avatar,
                        alt: _unref(resolveChallengerAvatar)(currentUser.value).printable_name
                      }, null, 8, _hoisted_3)
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_4
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_unref(matchInRunResultResolver)(_unref(getMatchResult)()).showCongratulation)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: require('@/assets/imgs/congratulations.png')
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, _toDisplayString(_unref(matchInRunResultResolver)(_unref(getMatchResult)()).text), 1)
              ]),
              _createElementVNode("p", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("img", {
                  src: require('@/assets/imgs/co_icon_orange.png')
                }, null, 8, _hoisted_9),
                _createElementVNode("strong", null, _toDisplayString(_unref(getMatchResult)().my_points) + " coins", 1)
              ]),
              _hoisted_10,
              (_unref(getMatchResult)().challenger_match && _unref(getMatchResult)().challenger_match.pivot.quiz)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("img", {
                      src: require('@/assets/imgs/co_icon_orange.png')
                    }, null, 8, _hoisted_13),
                    _createElementVNode("strong", null, _toDisplayString(_unref(getMatchResult)().challenger_match.pivot.points) + " coins", 1)
                  ]))
                : (_unref(getMatchResult)().challenger_match)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Non ha ancora iniziato il match "))
                  : (_openBlock(), _createElementBlock("p", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("img", {
                        src: require('@/assets/imgs/co_icon_orange.png')
                      }, null, 8, _hoisted_17),
                      _createElementVNode("strong", null, _toDisplayString(Math.round(_unref(getMatchResult)().quiz.quiz.length / 100 * 80)) + " coins", 1)
                    ])),
              _createElementVNode("section", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createVNode(_unref(IonButton), {
                    expand: "block share",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (setOpen(true)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.replace({name: 'play'})))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonModal), {
                    "is-open": isOpenRef.value,
                    onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (setOpen(false)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ModalCongratulationsResult, {
                        "quiz-result": _unref(getMatchResult)()
                      }, null, 8, ["quiz-result"])
                    ]),
                    _: 1
                  }, 8, ["is-open"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})